import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CompactDotsIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 15 4",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 4),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M2 3.8c1 0 1.7-.7 1.7-1.6C3.7 1.3 3 .6 2.1.6 1 .6.5 1.3.5 2.2c0 1 .7 1.6 1.6 1.6ZM12.5 3.8c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-1 0-1.6.7-1.6 1.6 0 1 .7 1.6 1.6 1.6ZM7.3 3.8c.9 0 1.6-.7 1.6-1.6C9 1.3 8.2.6 7.3.6c-1 0-1.6.7-1.6 1.6 0 1 .7 1.6 1.6 1.6Z"
    })
  });
};

export { CompactDotsIcon };
//# sourceMappingURL=dots.compact.js.map
